/**
 * @internal
 */
export enum ParticleInstanceVertexAttribute {
  ShapePositionStartLifeTime = "a_ShapePositionStartLifeTime",
  DirectionTime = "a_DirectionTime",
  StartColor = "a_StartColor",
  StartSize = "a_StartSize",
  StartRotation0 = "a_StartRotation0",
  StartSpeed = "a_StartSpeed",
  Random0 = "a_Random0",
  Random1 = "a_Random1",
  SimulationWorldPosition = "a_SimulationWorldPosition",
  SimulationWorldRotation = "a_SimulationWorldRotation",
  SimulationUV = "a_SimulationUV",
  Random2 = "a_Random2"
}
